import { basicPath } from '../basicPath';

export const fetchMemberLearningPlansStudent = (params) => async (dispatch) => {
    const path = '/mp/member/learning-plans/student';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
};


